import React from 'react';

export default function Heading(props) {
    return <h2 {...props} className={`text-lg md:text-2xl lg:text-3xl font-bold ${props.className}`}>
        { props.children }
    </h2>;
}
